import { pathAPI } from "../utils/pathApi";
import { useAPI } from "./api";

export const useSalon = ({
  page = 0,
  size = 10,
  ...props
}: {
  page: number;
  size: number;
  country?: string;
  search?: string;
  outlet_status?: string;
}) => {
  const { data, error, loading, mutate } = useAPI<{
    data: Salon[];
    total: number;
  }>(pathAPI.salons, true, { page, size, ...props });

  return [
    {
      data: data?.data || null,
      error,
      isLoading: loading,
      total: data?.total || 0,
    },
    { mutate },
  ] as const;
};

export const useSalonRegistration = ({
  page = 0,
  size = 10,
  ...props
}: {
  page: number;
  size: number;
  country?: string;
  search?: string;
  outlet_status?: string;
}) => {
  const { data, error, loading, mutate } = useAPI<{
    data: Salon[];
    total: number;
  }>(pathAPI.salonsRegistration, true, { page, size, ...props });
  return [
    {
      data: data?.data || null,
      error,
      isLoading: loading,
      total: data?.total || 0,
    },
    { mutate },
  ] as const;
};
export const useSalonRegistrationDetail = ({ id }: { id: string }) => {
  const { data, error, loading, mutate } = useAPI<{
    data: SalonRegistration;
  }>(pathAPI.salonsRegistrationDetail.replace(":id", id), true);
  return [
    {
      data: data?.data || null,
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};

export const useGetInfoSalon = ({ id }: { id: string }) => {
  console.log("=== useGetInfoSalon: ", id);
  const { data, error, loading, mutate } = useAPI<{
    data: SalonRegistration;
  }>(pathAPI.salonsRegistrationDetail.replace(":id", id), true);
  return [
    {
      data: data?.data || null,
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};

export const useGetSettingSalon = ({ id }: { id: string }) => {
  const { data, error, loading, mutate } = useAPI<{
    data: {
      id: number;
      owner_email: string;
      payment_method_limit: string;
      status: string;
    };
  }>(pathAPI.settingSalon.replace(":id", id), true);
  return [
    {
      data: data?.data || null,
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};
export const useGetPhotoSalon = ({ id }: { id: string }) => {
  const { data, error, loading, mutate } = useAPI<{
    data: {
      featured_photo: string;
      gallery: string[];
    };
  }>(pathAPI.photoSalon.replace(":id", id), true);
  return [
    {
      data: data?.data || { featured_photo: "", gallery: [] },
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};

export const useBussinessTypes = () => {
  const { data, error, loading, mutate } = useAPI<{
    data: {id: string, name: string}[];
  }>(pathAPI.bussinessTypes, true);
  return [
    {
      data: data?.data || [],
      error,
      isLoading: loading,
    },
    { mutate },
  ] as const;
};
